// import React, { useEffect, useState } from "react";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { Link } from "react-router-dom";
// import Footer1 from "../navbar/Footer1";

// const Home = () => {
//   const [banners, setBanners] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch banners from API
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const response = await fetch(
//           "https://vogelkoparchitects.com/api/api/banners/",
//         );
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();
//         // Sort banners by order property
//         const sortedBanners = data.sort((a, b) => a.order - b.order);
//         setBanners(sortedBanners);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching banners:", err);
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchBanners();
//   }, []);

//   useEffect(() => {
//     AOS.init({
//       duration: 600,
//       easing: "ease-in-out",
//       once: true,
//       mirror: false,
//     });

//     const toggleScrolled = () => {
//       const selectBody = document.querySelector("body");
//       const selectHeader = document.querySelector("#header");

//       if (!selectHeader) {
//         return;
//       }

//       if (
//         !selectHeader.classList.contains("scroll-up-sticky") &&
//         !selectHeader.classList.contains("sticky-top") &&
//         !selectHeader.classList.contains("fixed-top")
//       ) {
//         return;
//       }

//       window.scrollY > 100
//         ? selectBody.classList.add("scrolled")
//         : selectBody.classList.remove("scrolled");
//     };

//     window.addEventListener("scroll", toggleScrolled);
//     toggleScrolled();

//     const scrollTop = document.querySelector(".scroll-top");
//     if (scrollTop) {
//       const toggleScrollTop = () => {
//         window.scrollY > 100
//           ? scrollTop.classList.add("active")
//           : scrollTop.classList.remove("active");
//       };

//       scrollTop.addEventListener("click", (e) => {
//         e.preventDefault();
//         window.scrollTo({
//           top: 0,
//           behavior: "smooth",
//         });
//       });

//       window.addEventListener("scroll", toggleScrollTop);
//     }

//     return () => {
//       window.removeEventListener("scroll", toggleScrolled);
//     };
//   }, []);

//   // Initialize Bootstrap carousel after banners are loaded
//   useEffect(() => {
//     if (!loading && banners.length > 0) {
//       // Make sure we're using the right Bootstrap version
//       if (
//         typeof window !== "undefined" &&
//         window.bootstrap &&
//         window.bootstrap.Carousel
//       ) {
//         const carouselElement = document.querySelector("#hero-carousel");
//         if (carouselElement) {
//           // Destroy any existing carousel instance first
//           const existingCarousel =
//             window.bootstrap.Carousel.getInstance(carouselElement);
//           if (existingCarousel) {
//             existingCarousel.dispose();
//           }

//           // Initialize a new carousel
//           new window.bootstrap.Carousel(carouselElement, {
//             interval: 4000,
//             ride: "carousel",
//             pause: false,
//           });
//         }
//       }
//     }
//   }, [loading, banners]);

//   return (
//     <div>
//       <section id="hero" className="hero section dark-background">
//         <div className="hero_content">
//           <div data-aos="fade-up" data-aos-delay="100">
//             <h1>Vision Ahead</h1>
//             <div className="explore">
//               <p>
//                 <Link to="/Productcategory">
//                   <button>EXPLORE</button>
//                 </Link>
//               </p>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="text-center p-5">Loading carousel...</div>
//         ) : error ? (
//           <div className="text-center p-5 text-danger">
//             Error loading carousel: {error}
//           </div>
//         ) : (
//           <div
//             id="hero-carousel"
//             className="carousel slide"
//             data-bs-ride="carousel"
//             data-bs-pause="false"
//           >
//             <div className="carousel-indicators">
//               {banners.map((banner, index) => (
//                 <button
//                   key={`indicator-${banner.id}`}
//                   type="button"
//                   data-bs-target="#hero-carousel"
//                   data-bs-slide-to={index}
//                   className={index === 0 ? "active" : ""}
//                   aria-current={index === 0 ? "true" : "false"}
//                   aria-label={`Slide ${index + 1}`}
//                 ></button>
//               ))}
//             </div>

//             <div className="carousel-inner">
//               {banners.map((banner, index) => (
//                 <div
//                   className={`carousel-item ${index === 0 ? "active" : ""}`}
//                   key={banner.id}
//                   style={{
//                     backgroundImage: `url(${banner.image})`,
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                     height: "100vh",
//                   }}
//                 >
//                   {/* Empty div for the background image */}
//                 </div>
//               ))}
//             </div>

//             <button
//               className="carousel-control-prev"
//               type="button"
//               data-bs-target="#hero-carousel"
//               data-bs-slide="prev"
//             >
//               <span
//                 className="carousel-control-prev-icon"
//                 aria-hidden="true"
//               ></span>
//               <span className="visually-hidden">Previous</span>
//             </button>

//             <button
//               className="carousel-control-next"
//               type="button"
//               data-bs-target="#hero-carousel"
//               data-bs-slide="next"
//             >
//               <span
//                 className="carousel-control-next-icon"
//                 aria-hidden="true"
//               ></span>
//               <span className="visually-hidden">Next</span>
//             </button>
//           </div>
//         )}
//         <img src="assets/img/logo.png" alt="Logo" className="banner-img" />
//       </section>
//       <Footer1 />
//     </div>
//   );
// };

// export default Home;
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import Footer1 from "../navbar/Footer1";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const scrollTriggeredRef = useRef(false);
  const lastScrollYRef = useRef(0);
  // Changed from Productcategory to Works page
  const worksPagePath = "/works";

  // Fetch banners from API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(
          "https://vogelkoparchitects.com/api/api/banner/",
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        // Sort banners by order property
        const sortedBanners = data.sort((a, b) => a.order - b.order);
        
        setBanners(sortedBanners);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching banners:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    const toggleScrolled = () => {
      const selectBody = document.querySelector("body");
      const selectHeader = document.querySelector("#header");

      if (!selectHeader) {
        return;
      }

      if (
        !selectHeader.classList.contains("scroll-up-sticky") &&
        !selectHeader.classList.contains("sticky-top") &&
        !selectHeader.classList.contains("fixed-top")
      ) {
        return;
      }

      window.scrollY > 100
        ? selectBody.classList.add("scrolled")
        : selectBody.classList.remove("scrolled");
    };

    window.addEventListener("scroll", toggleScrolled);
    toggleScrolled();

    return () => {
      window.removeEventListener("scroll", toggleScrolled);
    };
  }, []);

  // Handle scroll to navigate to Works page
  useEffect(() => {
    const handleExploreScroll = (event) => {
      const currentScrollY = window.scrollY;
      const isWheelDown = event.type === "wheel" && event.deltaY > 0;
      const isScrollDown = event.type === "scroll" && currentScrollY > lastScrollYRef.current;

      if (scrollTriggeredRef.current) {
        return;
      }

      if (
        isWheelDown &&
        (currentScrollY > 100 || currentScrollY === 0)
      ) {
        scrollTriggeredRef.current = true;
        navigate(worksPagePath);
        return;
      }

      if (isScrollDown && currentScrollY > 100) {
        scrollTriggeredRef.current = true;
        navigate(worksPagePath);
      }

      lastScrollYRef.current = currentScrollY;
    };

    window.addEventListener("wheel", handleExploreScroll, { passive: true });
    window.addEventListener("scroll", handleExploreScroll, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleExploreScroll);
      window.removeEventListener("scroll", handleExploreScroll);
    };
  }, [navigate, worksPagePath]);

  // Initialize Bootstrap carousel after banners are loaded
  useEffect(() => {
    if (!loading && banners.length > 0) {
      // Make sure we're using the right Bootstrap version
      if (
        typeof window !== "undefined" &&
        window.bootstrap &&
        window.bootstrap.Carousel
      ) {
        const carouselElement = document.querySelector("#hero-carousel");
        if (carouselElement) {
          // Destroy any existing carousel instance first
          const existingCarousel =
            window.bootstrap.Carousel.getInstance(carouselElement);
          if (existingCarousel) {
            existingCarousel.dispose();
          }

          // Initialize a new carousel
          new window.bootstrap.Carousel(carouselElement, {
            interval: 3000,
            ride: "carousel",
            pause: false,
            wrap: true,
          });

          // Reset and play video when slide becomes active
          const handleSlide = (e) => {
            const activeSlide = e.relatedTarget;
            if (activeSlide) {
              const video = activeSlide.querySelector('video');
              if (video) {
                video.currentTime = 0;
                video.play().catch(err => console.log("Video auto-play prevented:", err));
              }
            }
          };

          carouselElement.removeEventListener('slid.bs.carousel', handleSlide);
          carouselElement.addEventListener('slid.bs.carousel', handleSlide);
        }
      }
    }
  }, [loading, banners]);

  return (
    <div>
      <section id="hero" className="hero section dark-background">
        <div className="explore">
          <p>
            <button
              id="exploreBtn"
              type="button"
              onClick={() => navigate(worksPagePath)}
            >
              EXPLORE
            </button>
          </p>
        </div>

        {loading ? (
          <div className="text-center p-5">Loading carousel...</div>
        ) : error ? (
          <div className="text-center p-5 text-danger">
            Error loading carousel: {error}
          </div>
        ) : (
          <div
            id="hero-carousel"
            className="carousel slide"
            data-bs-ride="carousel"
            data-bs-pause="false"
          >
            {/* Indicators hidden – video auto-advances to image slides */}

            <div className="carousel-inner">
              {banners.map((banner, index) => {
                const fallbacks = [
                  '/assets/img/hero-carousel/banner1.jpeg',
                  '/assets/img/hero-carousel/banner2.jpg',
                  '/assets/img/hero-carousel/banner3.jpg',
                  '/assets/img/hero-carousel/banner4.jpg',
                  '/assets/img/hero-carousel/banner5.jfif'
                ];
                const fallbackImage = fallbacks[index % fallbacks.length];
                
                return (
                  <div
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                    key={banner.id}
                    data-bs-interval={(banner.video || banner.video_url) ? "999999" : "3000"}
                    style={{
                      backgroundImage: `url(${banner.image && banner.image.trim() !== "" ? banner.image : fallbackImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "100vh",
                      position: "relative"
                    }}
                  >
                  {/* Video Background if available */}
                  {(banner.video || banner.video_url) && (
                    <video
                      autoPlay
                      muted
                      playsInline
                      onEnded={() => {
                        const carouselElement = document.querySelector("#hero-carousel");
                        if (carouselElement && window.bootstrap && window.bootstrap.Carousel) {
                          const bsCarousel = window.bootstrap.Carousel.getInstance(carouselElement);
                          if (bsCarousel) {
                            bsCarousel.next();
                          }
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 1
                      }}
                    >
                      <source src={banner.video || banner.video_url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  <div
                    className="banner-title-overlay"
                    style={{
                      position: "absolute",
                      bottom: "40px",
                      left: "40px",
                      textAlign: "left",
                      zIndex: 10,
                      color: "white",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                      padding: "20px",
                    }}
                  >
                    <h1 
                      data-aos="fade-up" 
                      data-aos-delay="100"
                      style={{
                        fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
                        fontWeight: "bold",
                        margin: 0,
                        letterSpacing: "2px",
                      }}
                    >
                      {banner.title}
                    </h1>
                  </div>
                  {/* Subtle overlay for all slides */}
                  <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.1)", zIndex: 2 }} />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
      <Footer1 />
    </div>
  );
};

export default Home;